import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { webDtos } from '@vectronic/openApi-customer';
import { Translator } from '@vectronic/util';
import { DetailsItemComponent } from '../details-item/details-item.component';

@Component({
  selector: 'vectronic-trap-status',
  templateUrl: './trap-status.component.html',
  styleUrls: ['./trap-status.component.scss'],
  imports: [CommonModule, DetailsItemComponent, MatButtonModule, MatIconModule],
})
export class TrapStatusComponent {
  lastTrapEvent = input<webDtos.TrapEvent>();

  convertSecondsToDateString(seconds: number) {
    return Translator.convertSecondsToDays(seconds);
  }
}
